import { AlertColor } from '@mui/material/Alert/Alert';
import { AppContext } from 'context/AppContextProvider';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from 'services/DefaultService';

export const LOGOUT_EVENT = 'app:logout';

export const useLogout = () => {
	const { showSnackbar, setIsOpenedSidebar } = useContext(AppContext);
	const navigate = useNavigate();

	return (message = 'Desconectado!', severity: AlertColor = 'info') => {
		sessionStorage.removeItem('token');
		api.defaults.headers.common.Authorization = undefined;
		setIsOpenedSidebar(false);
		window.dispatchEvent(new Event(LOGOUT_EVENT));
		navigate('/app/authentication/signIn', { replace: true });
		showSnackbar(message, severity);
	};
};
